import { initI18n } from 'common-react/src/i18n/initI18n.ts'
import { useEffect } from 'react'
import { Container } from './components/Container/Container'
import { useWidgetConfig } from './hooks/useWidgetConfig.ts'
import { trackEvent } from './services/rudderanalytics.ts'
import './services/sentry.ts'
import { setNectaryRegistries } from './utils/nectary.ts'

setNectaryRegistries(window.customElements)

initI18n()

function App() {
  const searchParams = new URLSearchParams(window.location.search)
  const widgetId = searchParams.get('widgetId') || ''
  const region = (searchParams.get('region') || '').toLowerCase()
  const { data, isError: fetchError } = useWidgetConfig({ widgetId, region })

  useEffect(() => {
    if (fetchError) {
      trackEvent('livechat_forwarding_page_error', { widgetId, region })
    }
  }, [fetchError, region, widgetId])

  if (!data) {
    return null
  }

  trackEvent('livechat_forwarding_page_opened', { widgetId, region })

  return (
    <div id='app' className='nectary-theme-base nectary-theme-message-media'>
      {fetchError ? (
        <sinch-inline-alert caption={'Service currently unavailable'} type={'info'} />
      ) : (
        <Container data={data} />
      )}
    </div>
  )
}

export default App
